import styled from 'styled-components';
import { rgba } from 'polished';

import { white, black } from 'styles/colors';
import { mMedium } from 'styles/typography';
import { slideIn } from 'styles/animation';
import { sectionWidth } from 'styles/spacings';

export const Wrapper = styled.section`
	background-color: ${white};
	max-width: ${sectionWidth};
	width: 100%;
	padding: 16px 32px 32px 32px;
	margin-top: 32px;
	box-shadow: 0 3px 10px 0 ${rgba('#000', 0.1)};
	animation-name: ${slideIn};
	animation-duration: 600ms;
	animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
	animation-delay: ${({ animationIndex }) => `${50 + animationIndex * 75}ms`};
	animation-fill-mode: both;

	&:first-child {
		margin-top: 0;
	}
`;

export const Title = styled.div`
	width: 100%;
	${mMedium};
	color: #1a1a1a;
	margin-bottom: 20px;
`;

export const ImportantDescriptionSection = styled.div`
	color: ${black};
	font-weight: bold;
	margin-top: 10px;
`;
